module.exports = __webpack_public_path__ + "img/qemu.f8c8483d.svg";